/** @format */

import React from 'react'

import { Row, Col } from 'antd'

import moment from 'moment'

import './style.css'

export default function PharmacyInfo(props) {
	return (
		<div className='ph-counter-order-detail-pharmacy-info-global-container'>
			<div className='ph-counter-order-detail-pharmacy-info-main-container'>
				<h1 className='ph-counter-order-detail-pharmacy-info-main-title'>
					Informacion de Farmacia
				</h1>
				<Row>
					<Col lg={12}>
						<h1 className='ph-counter-order-detail-pharmacy-info-main-titles'>Farmacia:</h1>
						<h1 className='ph-counter-order-detail-pharmacy-info-main-titles'>Local:</h1>
						<h1 className='ph-counter-order-detail-pharmacy-info-main-titles'>Comuna:</h1>
						<h1 className='ph-counter-order-detail-pharmacy-info-main-titles'>Región:</h1>
						<h1 className='ph-counter-order-detail-pharmacy-info-main-titles'>Dirección:</h1>
						<h1 className='ph-counter-order-detail-pharmacy-info-main-titles'>Cantidad:</h1>
						{!!props.comment && (
							<h1 className='ph-counter-order-detail-pharmacy-info-main-titles'>Comentario:</h1>
						)}
						{!!props.pharmacyInfo.price && (
							<Col span={12}>
								<h1 className='ph-counter-order-detail-pharmacy-info-main-titles'>
									Precio seleccionado:
								</h1>
							</Col>
						)}
						{!!props.pharmacyInfo.estimated_date && (
							<Col span={12}>
								<h1 className='ph-counter-order-detail-pharmacy-info-main-titles'>
									Fecha y hora estimada:
								</h1>
							</Col>
						)}
						{props.status.status !== 500 && !!props.status.reason && (
							<h1 className='ph-counter-order-detail-pharmacy-info-main-titles'>Observación:</h1>
						)}
					</Col>
					<Col lg={12}>
						<h1 className='ph-counter-order-detail-pharmacy-info-main-subtitles'>
							{props.pharmacyInfo.pharmacy}
						</h1>
						<h1 className='ph-counter-order-detail-pharmacy-info-main-subtitles'>
							{props.pharmacyInfo.local_info.local}
						</h1>
						<h1 className='ph-counter-order-detail-pharmacy-info-main-subtitles'>
							{props.pharmacyInfo.local_info.commune}
						</h1>
						<h1 className='ph-counter-order-detail-pharmacy-info-main-subtitles'>
							{props.pharmacyInfo.local_info.region}
						</h1>
						<h1 className='ph-counter-order-detail-pharmacy-info-main-subtitles'>
							{props.pharmacyInfo.local_info.direction}
						</h1>
						<h1 className='ph-counter-order-detail-pharmacy-info-main-subtitles'>
							{props.pharmacyInfo.quantity}
						</h1>
						{!!props.comment && (
							<h1 className='ph-counter-order-detail-pharmacy-info-main-subtitles'>
								{props.comment}
							</h1>
						)}
						{!!props.pharmacyInfo.price && (
							<Col span={12}>
								<h1 className='ph-counter-order-detail-pharmacy-info-main-subtitles'>
									$ {props.pharmacyInfo.price}
								</h1>
							</Col>
						)}
						{!!props.pharmacyInfo.estimated_date && (
							<Col span={12}>
								<h1 className='ph-counter-order-detail-pharmacy-info-main-subtitles'>
									{moment(props.pharmacyInfo.estimated_date).format('Do MMMM YYYY HH:mm:ss')}
								</h1>
							</Col>
						)}
						{props.status.status !== 500 && !!props.status.reason && (
							<h1 className='ph-counter-order-detail-pharmacy-info-main-subtitles'>
								{props.status.reason}
							</h1>
						)}
					</Col>
				</Row>
			</div>
		</div>
	)
}
